/* eslint-disable camelcase */

import { makeAutoObservable, set } from 'mobx'
import Client from './Client'

class ClientsSynced {
  CuAccountNumber = ''
  CuActive = 0
  CuAddress = ''
  CuBoAllowed = 0
  CuBranchNumber = ''
  CuCareOf = ''
  CuCity = ''
  CuComment = ''
  CuCustomerUsed = 0
  CuDepositAllowed = null
  CuDiscountAllowed = 0
  CuDiscountCP = 0
  CuDiscountNumber = 0
  CuDiscountTaxesShipping = 0
  CuEMail = ''
  CuEMail2 = ''
  CuEMail3 = ''
  CuExemptedTaxCP1 = 0
  CuExemptedTaxCP2 = 0
  CuExemptedTaxCP3 = 0
  CuExemptedTaxCP4 = 0
  CuExemptedTaxCP5 = 0
  CuExemptedTaxNumber1 = ''
  CuExemptedTaxNumber2 = ''
  CuExemptedTaxNumber3 = ''
  CuExemptedTaxNumber4 = ''
  CuExemptedTaxNumber5 = ''
  CuExemptionNumber1 = ''
  CuExemptionNumber2 = ''
  CuExemptionNumber3 = ''
  CuExemptionNumber4 = ''
  CuExemptionNumber5 = ''
  CuISOCountryCode = ''
  CuInstitutionNumber = ''
  CuInterest = 0
  CuInvoicedToCP = 0
  CuInvoicedToNumber = ''
  CuLanguage = 0
  CuMarginLimit = 0
  CuMarginType = 0
  CuName = ''
  CuNumber = ''
  CuOpeningDate = ''
  CuOverTheCounterCustomer = 0
  CuPhoneDescription1 = ''
  CuPhoneDescription2 = ''
  CuPhoneDescription3 = ''
  CuPhoneDescription4 = ''
  CuPhoneExtention1 = ''
  CuPhoneExtention2 = ''
  CuPhoneExtention3 = ''
  CuPhoneExtention4 = ''
  CuPhoneNumber1 = ''
  CuPhoneNumber2 = ''
  CuPhoneNumber3 = ''
  CuPhoneNumber4 = ''
  CuPostalCode = ''
  CuPriceLevel = 0
  CuProjectCP = 0
  CuProjectNumber = ''
  CuQtyOfCheckNSF = 0
  CuQtyOfCreditNotice = 0
  CuReceivable = 0
  CuReferenceDate1 = ''
  CuReferenceDate2 = ''
  CuReferenceDescription1 = ''
  CuReferenceDescription2 = ''
  CuSalesRepCP = 0
  CuSalesRepNumber = 0
  CuSendInvoiceByEmail = 0
  CuSendStatementByEmail = 0
  CuShippingCP = 0
  CuShippingNumber = 0
  CuSortKey = ''
  CuStatement = 0
  CuTaxGroupCP = 0
  CuTaxGroupNumber = ''
  CuTermCP = 0
  CuTermNumber = 0
  CuTerritoryCP = 0
  CuTerritoryNumber = 0
  CuTimeModified = ''
  CuUnique = 0
  CuUniqueUser = 0
  CuUsed = 0
  CuWebAddress = ''
  CuWithdrawalAllowed = 0
  PK_Number = ''
  RecCardPos = 0
  UpdateSessionId = null

  /**
   *
   * @type {array<ClientsSynced>}
   */
  clients_childs_synced = []
  /**
   *
   * @type {Client}
   */
  client = null

  get fullAddress () {
    let result = ''
    if (this.CuAddress) {
      result += this.CuAddress
    }
    if (this.CuCity) {
      result += `, ${this.CuCity}`
    }
    if (this.CuPostalCode) {
      result += `, ${this.CuPostalCode}`
    }

    return result.trim()
  }

  constructor (data) {
    const { client, clients_childs_synced, ...rest } = data
    if (client) {
      this.client = new Client()
      this.client.setOriginalData(client)
    }
    if (clients_childs_synced) {
      for (const clientsChildsSynced of data.clients_childs_synced) {
        this.clients_childs_synced.push(new ClientsSynced(clientsChildsSynced))
      }
    }
    makeAutoObservable(this)
    set(this, rest)
  }
}

export default ClientsSynced
